import { useRootStore } from '@/providers/root-store-provider';
import { myServicesData } from '@/services/api/services-api';
import { VEPCodes } from '@/utils/utils';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

// Function to validate insurance data completeness
const validateInsuranceDataComplete = (
  services: myServicesData[],
  serviceId?: string
) => {
  let servicesToCheck = serviceId
    ? services.filter(
        (service) =>
          service.id === serviceId &&
          !VEPCodes.includes(service.organization.code)
      )
    : services.filter(
        (service) => !VEPCodes.includes(service.organization.code)
      );

  // TODO: Remove filter
  const participantsInEachSale = servicesToCheck
    .filter(
      (service) =>
        service.saleItems.length > 0 &&
        !service.saleItems[0].service.showOnlyInLanding
    )
    .map((service) => service.participants);
  return participantsInEachSale.every((sale) =>
    sale.every((participant) => participant.hasFilledData)
  );
};

const useInsuranceDataComplete = (serviceId?: string) => {
  const setIsInsuranceDataComplete = useRootStore(
    (store) => store.setIsInsuranceDataComplete
  );
  const queryClient = useQueryClient();
  const myServices: myServicesData[] | undefined = queryClient.getQueryData([
    'myServices'
  ]);

  useEffect(() => {
    if (myServices) {
      const isAllFilled = validateInsuranceDataComplete(myServices, serviceId);
      setIsInsuranceDataComplete(isAllFilled);
    }
  }, [myServices, setIsInsuranceDataComplete, serviceId]);
};

export default useInsuranceDataComplete;
